<template>
  <div class="course-list">
    <b-list-group id="course" role="tabpanel">
      <b-list-group-item
        v-for="course in coursePlans"
        :key="course.id"
        class="course-item d-flex align-items-center justify-content-between"
        @click.stop="changeCourse(course)"
      >
        <i
          v-if="course.type === 'OFFICIAL'"
          class="icon-Floral-Check text-16"
        ></i>
        <i v-else-if="course.type === 'MASTER'" class="icon-Friend text-16"></i>
        <div class="course-name">{{ $t(course.name) }}</div>
        <b-badge v-if="course.isNew" variant="accent">NEW</b-badge>
        <i
          class="icon-Heart text-24"
          :class="{favorite: course.isFavorite}"
          @click.stop.prevent="favoriteCourse(course)"
        ></i>
      </b-list-group-item>
    </b-list-group>
  </div>
</template>

<script>
import {TAGS} from '@/constant/coursePlan';
export default {
  computed: {
    currentPlan() {
      return this.$store.getters['course/currentPlan'];
    },
    coursePlans() {
      const plans = this.$store.getters['course/plans'];
      const showPlanList = plans.filter((plan) =>
        plan.tags?.includes(TAGS.SHOW_IN_LIST)
      );
      // 排序規則：
      // 1. 有被標選為我的最愛者往前排
      // 2. 我的最愛的時間最新的在最上面
      return [...showPlanList].sort((a, b) => {
        const aIsFavorite = a.isFavorite || false;
        const bIsFavorite = b.isFavorite || false;

        // 如果兩者的最愛狀態不同，最愛的排在前面
        if (aIsFavorite !== bIsFavorite) {
          return bIsFavorite ? 1 : -1;
        }

        // 如果兩者都是最愛，按 setFavoriteAt 降序排序（最新的在前）
        if (aIsFavorite && bIsFavorite) {
          return (b.setFavoriteAt || 0) - (a.setFavoriteAt || 0);
        }

        // 都不是最愛的情況，保持原有順序
        return 0;
      });
    },
  },
  methods: {
    changeCourse(course) {
      this.$emit('change-course', course);
    },
    favoriteCourse(course) {
      this.$emit('favorite-course', course);
    },
  },
};
</script>

<style lang="scss" scoped>
.course-list {
  .list-group-item {
    border: 0px;
    border-bottom: 1px solid var(--Line-Line, #dcdfe5);
    padding: 0px 8px;
    gap: 8px;
    height: 50px;
  }
  .icon-Floral-Check,
  .icon-Friend {
    color: white;
    border-radius: 50%;
    padding: 2px;
  }
  .icon-Floral-Check {
    background: $secondary;
  }
  .icon-Friend {
    background: #c0c4cc;
  }
  .course-name {
    text-overflow: ellipsis;
    white-space: nowrap;
    width: 100%;
    overflow: hidden;
    flex-grow: 1;
  }
}

.icon-Heart {
  color: $grayscale-gray;
  &.favorite {
    color: $primary;
  }
}
</style>
